import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    downloadErrorMessage: null,
    downloadStatusLoading: false,
    downloadStatus: null,

    startDownloadLoading: false,
    startFilterDownloadLoading: false,
    downloadMonthModal: false,
    downloadSelectionModal: false,
    downloadSelection: [],
    downloadRequestId: null,
    downloadSuccessMessage: null,
    downloadWarningMessage: null,
};

const pathwayBillingDownloadSlice = createSlice({
    name: "PathwayBillingDownload",
    initialState,
    reducers: {
        getDownloadStatusRequest(state) {
            state.downloadStatusLoading = true;
            state.downloadWarningMessage = null;
        },
        getDownloadStatusSuccess(state, action) {
            state.downloadStatusLoading = false;
            state.downloadStatus = action.payload;
        },
        getDownloadStatusFailure(state, action) {
            state.downloadStatusLoading = false;
            state.downloadErrorMessage = action.payload;
        },
        toggleDownloadMonthModal(state) {
            state.downloadMonthModal = !state.downloadMonthModal;
            state.startDownloadLoading = false;
            state.downloadStatusLoading = false;
            state.downloadErrorMessage = null;
            state.downloadRequestId = null;
            state.downloadWarningMessage = null;
        },
        startDownloadMonthRequest(state) {
            state.startDownloadLoading = true;
            state.downloadErrorMessage = null;
            state.downloadWarningMessage = null;
        },
        startDownloadMonthSuccess(state, action) {
            state.startDownloadLoading = false;
            state.downloadStatus = action.payload;
            state.downloadWarningMessage = action.payload.warningMessage;
        },
        startDownloadMonthFailure(state, action) {
            state.startDownloadLoading = false;
            state.downloadErrorMessage = action.payload;
        },

        startFilterDownloadRequest(state) {
            state.startFilterDownloadLoading = true;
            state.filterDownloadErrorMessage = null;
            state.filterDownloadWarningMessage = null;
        },
        startFilterDownloadSuccess(state, action) {
            state.startFilterDownloadLoading = false;
            state.filterDownloadErrorMessage = null;
            state.filterDownloadWarningMessage = null;
            if (action.payload && action.payload.warningMessage) {
                state.downloadWarningMessage = action.payload.warningMessage;
            }
        },
        startFilterDownloadFailure(state, action) {
            state.startFilterDownloadLoading = false;
            state.filterDownloadWarningMessage = null;
            state.filterDownloadErrorMessage = action.payload;
        },

        toggleDownloadSelectionModal(state) {
            if (state.downloadSelectionModal) {
                state.downloadSelection = [];
            }
            state.downloadSelectionModal = !state.downloadSelectionModal;
            state.startDownloadLoading = false;
            state.downloadStatusLoading = false;
            state.downloadErrorMessage = null;
            state.downloadRequestId = null;
        },
        addDownloadSelection(state, action) {
            state.downloadSelection = [...state.downloadSelection, action.payload];
        },
        removeDownloadSelection(state, action) {
            let index = state.downloadSelection.findIndex((item) => {
                return item === action.payload;
            });
            state.downloadSelection.splice(index, 1);
        },
        startDownloadSelectionRequest(state) {
            state.startDownloadLoading = true;
            state.downloadErrorMessage = null;
            state.downloadRequestId = false;
        },
        startDownloadSelectionSuccess(state, action) {
            state.startDownloadLoading = false;
            state.downloadRequestId = action.payload;
        },
        startDownloadSelectionFailure(state, action) {
            state.startDownloadLoading = false;
            state.downloadErrorMessage = action.payload;
        },

        unlockBulkDownloadRequest(state) {
            state.unlockDownloadLoading = true;
            state.unlockDownloadErrorMessage = null;
        },
        unlockBulkDownloadSuccess(state, action) {
            state.unlockDownloadLoading = false;
            state.downloadStatus = action.payload;
        },
        unlockBulkDownloadFailure(state, action) {
            state.unlockDownloadLoading = false;
            state.unlockDownloadErrorMessage = action.payload;
        },
    },
});

export default pathwayBillingDownloadSlice;
